// Carbon footprint
export const GET_CARBON_TAG = 'GET_CARBON'

// Booking
export const GET_CLIENT_ASSETS = 'GET_CLIENT_ASSETS'
export const GET_CLIENT_ASSET = 'GET_CLIENT_ASSET'
export const GET_BOOKING_INQIURIES = 'GET_BOOKING_INQIURIES'
export const GET_ASSETS_FOR_BOOKING_BY_ID = 'GET_ASSETS_FOR_BOOKING_BY_ID'

// Board tasks
export const GET_BOARD_TASKS = 'GET_BOARD_TASKS_QUERY'

// Board meeting
export const GET_PROPOSED_FOR_EDITING = 'GET_PROPOSED_FOR_EDITING'
export const GET_SIGNING_DETAILS = 'GET_SIGNING_DETAILS'
export const GET_CASE_DETAIL_ATTACHMENTS = 'GET_CASE_DETAIL_ATTACHMENTS'
export const GET_PROPOSED_CASES = 'GET_PROPOSED_CASES'

// Signigns
export const GET_SIGNINGS = 'GET_SIGNINGS'

// Messages
export const GET_MESSAGE_LIST = 'GET_MESSAGE_LIST'
export const GET_MESSAGE_LISTITEM = 'GET_MESSAGE_LISTITEM'
export const GET_MESSAGE_THREAD = 'GET_MESSAGE_THREAD'

// Product catalog
export const GET_MY_ORDERS = 'GET_MY_ORDERS'

// Used in userApi only.
export const GET_USER_NOTIFICATIONS_TAG = 'GET_USER_NOTIFICATIONS'
export const GET_USER_SETTINGS_TAG = 'GET_USER_SETTINGS'

// Used in clientApi only.
export const GET_CLIENT_TAG = 'GET_CLIENT_TAG'

// Insurance claim
export const GET_INSURANCE_BUILDING_FILTERS = 'GET_INSURANCE_BUILDING_FILTERS'
export const GET_INSURANCE_UNIT_FILTERS = 'GET_INSURANCE_UNIT_FILTERS'
export const GET_INSURANCE_CLAIMS = 'GET_INSURANCE_CLAIMS'
export const GET_INSURANCE_CLAIM = 'GET_INSURANCE_CLAIM'

// Publications
export const GET_PUBLICATIONS = 'GET_PUBLICATIONS'

// Loan
export const GET_LOANS = 'GET_LOANS'
export const GET_LOAN_DETAILS = 'GET_LOAN_DETAILS'
export const GET_LOAN_REPAYMENTS_PER_YEAR = 'GET_LOAN_REPAYMENTS_PER_YEAR'
export const GET_LOAN_INTEREST_RATE_CHANGE = 'GET_LOAN_INTEREST_RATE_CHANGE'

//Budget
export const GET_BUDGET_ASSUMPTIONS = 'GET_BUDGET_ASSUMPTIONS'
export const GET_BUDGET_ASSUMPTIONS_CATEGORIES =
  'GET_BUDGET_ASSUMPTIONS_CATEGORIES'
export const GET_IMPORTANT_BUDGET_ASSUMPTIONS =
  'GET_IMPORTANT_BUDGET_ASSUMPTIONS'
export const GET_LARGEST_BUDGET_CHANGES_LINES =
  'FETCH_LARGEST_BUDGET_CHANGES_LINES'
export const GET_LARGEST_BUDGET_LINES = 'FETCH_LARGEST_BUDGET_LINES'
export const GET_BUDGET_SPECIFICATION = 'GET_BUDGET_SPECIFICATION'
export const GET_BUDGET_SPECIFICATIONS = 'GET_BUDGET_SPECIFICATIONS'
export const GET_BUDGET_LINES = 'GET_BUDGET_LINES'
export const GET_BUDGET_LINE_HISTORY = 'GET_BUDGET_LINE_HISTORY'
export const GET_BUDGET_HISTORY = 'GET_BUDGET_HISTORY'
export const GET_BUDGET_APPROVALS = 'GET_BUDGET_APPROVALS'
export const GET_BUDGET = 'GET_BUDGET'
export const GET_BUDGETS = 'GET_BUDGETS'
export const GET_BUDGET_LINE_DETAILS = 'GET_BUDGET_LINE_DETAILS'
export const GET_BUDGET_DEPARTMENTS = 'GET_BUDGET_DEPARTMENTS'
export const GET_BUDGET_SIMULATION_LINES = 'GET_BUDGET_SIMULATION_LINES'
export const GET_SPECIFIC_KONTERING = 'GET_SPECIFIC_KONTERING'
export const GET_BUDGET_NOTE = 'GET_BUDGET_NOTE'
export const GET_BUDGET_COMMENTS = 'GET_BUDGET_COMMENTS'
export const GET_BUDGET_APPROVAL_DEADLINE = 'GET_BUDGET_APPROVAL_DEADLINE'
// Notice polls
export const GET_POLLS = 'GET_POLLS'

// Comments
export const GET_COMMENTS = 'GET_COMMENTS'

// Meetings (avtal møte)
export const GET_MEETINGS = 'GET_MEETINGS'
export const GET_MEETING = 'GET_MEETING'

// Reimbursement
export const GET_REIMBURSEMENT = 'GET_REIMBURSEMENT'
export const GET_ALL_REIMBURSEMENTS = 'GET_ALL_REIMBURSEMENTS'

// Really Agreemenets
export const GET_PROPOSED_REALLY_AGREEMENTS = 'GET_PROPOSED_REALLY_AGREEMENTS'

// Portal Documents
export const GET_BOARD_DOCUMENT_DETAILS = 'GET_BOARD_DOCUMENT_DETAILS'
export const GET_BOARD_DOCUMENTS = 'GET_BOARD_DOCUMENTS'
export const GET_BOARD_DOCUMENTS_WITH_SEARCHTEXT =
  'GET_BOARD_DOCUMENTS_WITH_SEARCHTEXT'
export const GET_BOARD_TRASH_DOCUMENTS = 'GET_BOARD_TRASH_DOCUMENTS'

// Labels
export const GET_LABELS = 'GET_LABELS'
export const CREATE_LABEL = 'CREATE_LABEL'
export const UPDATE_LABEL = 'UPDATE_LABEL'

// Invoice
export const GET_INVOICE_APPROVALS = 'GET_INVOICE_APPROVALS'
export const GET_HISTORIC_APPROVALS = 'GET_HISTORIC_APPROVALS'
export const GET_INVOICE_ARCHIVE = 'GET_INVOICE_ARCHIVE'
export const GET_INVOICE = 'GET_INVOICE'
export const GET_ALLOCATION_RULES = 'GET_ALLOCATION_RULES'
export const GET_ACCOUNTANT_NOTE = 'GET_ACCOUNTANT_NOTE'

// Cohabitants
export const GET_COHABITANTS = 'GET_COHABITANTS'

// Email
export const GET_EMAIL = 'GET_EMAIL'

// New Annual Meetings
export const GET_ANNUAL_MEETINGS = 'GET_ANNUAL_MEETINGS'
export const GET_ANNUAL_MEETINGS_AVAILABLE_TIME_SLOTS =
  'GET_ANNUAL_MEETINGS_AVAILABLE_TIME_SLOTS'
export const GET_ANNUAL_MEETING_BY_ID = 'GET_ANNUAL_MEETING_BY_ID'
export const GET_ANNUAL_MEETING_PROGRESSPLAN = 'GET_ANNUAL_MEETING_PROGRESSPLAN'
export const GET_ANNUAL_MEETING_SECTIONS = 'GET_ANNUAL_MEETING_SECTIONS'

const TAGS = [
  GET_CARBON_TAG,
  GET_SIGNING_DETAILS,
  GET_CASE_DETAIL_ATTACHMENTS,
  GET_CLIENT_ASSETS,
  GET_CLIENT_ASSET,
  GET_PROPOSED_FOR_EDITING,
  GET_BOOKING_INQIURIES,
  GET_ASSETS_FOR_BOOKING_BY_ID,
  GET_BOARD_TASKS,
  GET_SIGNINGS,
  GET_MESSAGE_LIST,
  GET_MESSAGE_THREAD,
  GET_MESSAGE_LISTITEM,
  GET_MY_ORDERS,
  GET_INSURANCE_CLAIMS,
  GET_PROPOSED_CASES,
  GET_PUBLICATIONS,
  GET_LOANS,
  GET_LOAN_DETAILS,
  GET_LOAN_REPAYMENTS_PER_YEAR,
  GET_LOAN_INTEREST_RATE_CHANGE,
  GET_BUDGET_ASSUMPTIONS,
  GET_BUDGET_ASSUMPTIONS_CATEGORIES,
  GET_IMPORTANT_BUDGET_ASSUMPTIONS,
  GET_LARGEST_BUDGET_CHANGES_LINES,
  GET_LARGEST_BUDGET_LINES,
  GET_BUDGET_SPECIFICATION,
  GET_BUDGET_SPECIFICATIONS,
  GET_BUDGET_LINES,
  GET_BUDGET_LINE_HISTORY,
  GET_BUDGET_HISTORY,
  GET_BUDGET_APPROVALS,
  GET_BUDGET,
  GET_BUDGETS,
  GET_POLLS,
  GET_BUDGET_LINE_DETAILS,
  GET_COMMENTS,
  GET_MEETINGS,
  GET_MEETING,
  GET_REIMBURSEMENT,
  GET_ALL_REIMBURSEMENTS,
  GET_PROPOSED_REALLY_AGREEMENTS,
  GET_BOARD_DOCUMENT_DETAILS,
  GET_BOARD_DOCUMENTS,
  GET_BOARD_DOCUMENTS_WITH_SEARCHTEXT,
  GET_LABELS,
  CREATE_LABEL,
  UPDATE_LABEL,
  GET_INVOICE_APPROVALS,
  GET_HISTORIC_APPROVALS,
  GET_INVOICE_ARCHIVE,
  GET_INVOICE,
  GET_ALLOCATION_RULES,
  GET_ACCOUNTANT_NOTE,
]

export default TAGS
